export default {
    root: ({context, props, parent}) => ({
        class: [
            // Font
            'leading-[normal]',

            // Spacing
            'm-0',
            'p-3',

            // Shape
            'rounded-md',

            // Colors
            'text-stone-600 dark:text-stone-200',
            'placeholder:text-stone-400 dark:placeholder:text-stone-500',
            'bg-stone-50 dark:bg-stone-900',
            'border',
            {'border-stone-300 dark:border-stone-600': !props.invalid},

            // Invalid State
            {'border-red-500 dark:border-red-400': props.invalid},

            // States
            {
                'hover:border-askr-green': !context.disabled && !props.invalid,
                'focus:outline-none focus:outline-offset-0 focus:ring focus:ring-askr-green-500/50 dark:focus:ring-askr-green-400/50': !context.disabled,
                'opacity-60 select-none pointer-events-none cursor-default': context.disabled
            },

            // Filled State *for FloatLabel
            {filled: parent.instance?.$name == 'FloatLabel' && props.modelValue !== null && props.modelValue?.length !== 0},

            // Misc
            'appearance-none',
            'transition-colors duration-200'
        ]
    })
};
